import { apiGet, apiDel, apiPatch, apiPost } from "./helpers/api";
import { normalize, schema } from "normalizr";
import { notifySubmitError, notifySubmitSucceeded } from "./notifierProcesses";
import toQueryString from "../utils/toQueryString";

const subscriptionSchema = new schema.Entity("subscriptions");

export const fetchSubscriptions = (dispatch) => {
  dispatch({ type: "SUBSCRIPTIONS_FETCH_REQUESTED" });
  return apiGet("/api/v1/subscriptions").then((response) => {
    dispatch({
      type: "SUBSCRIPTIONS_FETCHED",
      ...normalize(response.body.data, [subscriptionSchema]),
    });
  }).catch(() => {
    dispatch({ type: "SUBSCRIPTIONS_FETCH_FAILED" });
  });
};

export const fetchProductSubscriptions = (dispatch, productId, page = 1) => {
  dispatch({ type: "PRODUCT_SUBSCRIPTIONS_FETCH_REQUESTED" });

  const searchQuery = toQueryString({ courseOfferProductIdEq: productId });
  return apiGet(`/api/v1/subscriptions?${searchQuery}page=${page}`).then((response) => {
    dispatch({
      type: "PRODUCT_SUBSCRIPTIONS_FETCHED",
      ...normalize(response.body.data, [subscriptionSchema]),
      productId,
      pagination: {
        totalPages: response.body.totalPages,
        totalCount: response.body.totalCount,
        currentPage: response.body.currentPage,
      },
    });
  }).catch(() => {
    dispatch({ type: "PRODUCT_SUBSCRIPTIONS_FETCH_ERROR" });
  });
};

export const cancelSubscription = (dispatch, subscriptionId, refundLastPayment = false) => {
  return apiDel(`/api/v1/subscriptions/${subscriptionId}?refund_last_payment=${refundLastPayment}`).then((response) => {
    dispatch({
      type: "SUBSCRIPTION_UPDATED",
      ...normalize(response.body.data, subscriptionSchema),
    });

    notifySubmitSucceeded(
      dispatch,
      refundLastPayment ? "Assinatura cancelada com sucesso! O estorno está sendo processado."
        : "Assinatura cancelada com sucesso! Você manterá o acesso até o fim do período pago."
    );
  }).catch((error) => {
    const errors = error?.response?.body?.errors;
    const errorMessage = Array.isArray(errors) ? errors[0]
      : errors || "Ocorreu um erro ao cancelar sua assinatura. Tente novamente mais tarde.";

    notifySubmitError(dispatch, {
      title: "Erro ao cancelar assinatura",
      message: errorMessage,
    });

    throw error;
  });
};

export const retrySubscriptionCharge = (dispatch, subscriptionId, cardId) => {
  return apiPost(`/api/v1/subscriptions/${subscriptionId}/retry_charge`)
    .send({ card_id: cardId })
    .then((response) => {
      dispatch({
        type: "SUBSCRIPTION_UPDATED",
        ...normalize(response.body.data, subscriptionSchema),
      });

      notifySubmitSucceeded(dispatch, "Cobrança gerada com sucesso!");
      return response;
    })
    .catch((error) => {
      const errors = error?.response?.body?.errors;
      const errorMessage = Array.isArray(errors) ? errors[0]
        : errors || "Ocorreu um erro ao gerar a cobrança. Tente novamente mais tarde.";

      notifySubmitError(dispatch, {
        title: "Erro ao gerar cobrança",
        message: errorMessage,
      });

      throw error;
    });
};

export const resumeSubscription = (dispatch, subscriptionId, { cardId }) => {
  return apiPost(`/api/v1/subscriptions/${subscriptionId}/resume`)
    .send({ card_id: cardId })
    .then((response) => {
      dispatch({
        type: "SUBSCRIPTION_UPDATED",
        ...normalize(response.body.data, subscriptionSchema),
      });

      return response;
    });
};

// Acompanha a 1ª cobrança de uma renovação que voltou "processando".
// `subscriptionId` é a assinatura original; `paymentId`, o da tentativa.
export const fetchResumeStatus = (subscriptionId, paymentId) => {
  return apiGet(`/api/v1/subscriptions/${subscriptionId}/resume_status?payment_id=${paymentId}`)
    .then((response) => response.body);
};

export const removeSubscription = (dispatch, id) => {
  dispatch({ type: "SUBSCRIPTION_REMOVED", id });
};

export const updateSubscriptionPaymentMethod = (dispatch, subscriptionId, cardData) => {
  return apiPatch(`/api/v1/subscriptions/${subscriptionId}/update_payment_method`)
    .send({ card: cardData })
    .then((response) => {
      dispatch({
        type: "SUBSCRIPTION_UPDATED",
        ...normalize(response.body.data, subscriptionSchema),
      });

      notifySubmitSucceeded(dispatch, "Cartão de crédito atualizado com sucesso!");
      return response;
    })
    .catch((error) => {
      const errorMessage = error?.response?.body?.error
        || "Ocorreu um erro ao atualizar o cartão. Tente novamente mais tarde.";

      notifySubmitError(dispatch, {
        title: "Erro ao atualizar cartão",
        message: errorMessage,
      });

      throw error;
    });
};
